/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refineexamplebrighten2Inputs */

const en_refineexamplebrighten2 = /** @type {(inputs: Refineexamplebrighten2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brighten`)
};

const de_refineexamplebrighten2 = /** @type {(inputs: Refineexamplebrighten2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufhellen`)
};

/**
* | output |
* | --- |
* | "Brighten" |
*
* @param {Refineexamplebrighten2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const refineexamplebrighten2 = /** @type {((inputs?: Refineexamplebrighten2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refineexamplebrighten2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_refineexamplebrighten2(inputs)
	return de_refineexamplebrighten2(inputs)
});
export { refineexamplebrighten2 as "refineExampleBrighten" }